import { useMemo } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { ANYWHERE_PLACE_ID } from 'constants/search'
import { LOOKING_FOR_SOMETHING_ELSE_CONTENT } from '../LookingForSomethingElse/constants'
import { isManualSortingEnabledFor } from 'selectors/featuresSelectors'
import OfferCarouselLookingForSomethingElse from '../LookingForSomethingElse/OfferCarouselLookingForSomethingElse'
import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import Places from 'constants/places'
import { getToursOfferListFilters } from 'home/helpers'

interface Props {
  title?: React.ReactNode
  excludedIds?: Array<string>
  minimumOffersCount?: number
}

function TourOfferCarousel(props: Props) {
  const { title, excludedIds, minimumOffersCount } = props
  const intl = useIntl()
  const isToursManualSortingEnabled = isManualSortingEnabledFor('tours')
  const offerListFilters = useMemo(() => getToursOfferListFilters(isToursManualSortingEnabled), [isToursManualSortingEnabled])
  const to = useMemo(() => {
    if (offerListFilters.destinationId && offerListFilters.destinationId !== ANYWHERE_PLACE_ID) {
      const query = {
        destinationId: offerListFilters.destinationId,
        destinationName: offerListFilters.destinationName ?? '',
      }
      return `/search/tours?${new URLSearchParams(query)}`
    }
    return LOOKING_FOR_SOMETHING_ELSE_CONTENT.tours.to
  }, [offerListFilters])

  const defaultTitle = useMemo(
    () =>
      intl.formatMessage(
        {
          id: 'Hjffn1w7Etb5Pf0sTvT1',
          defaultMessage: 'Once-in-a-lifetime <i>tours</i>',
        },
        {
          i: (chunks: React.ReactNode) => <i key="italic">{chunks}</i>,
        },
      ),
    [intl],
  )

  return (
    <OfferCardCarouselSection
      filters={offerListFilters}
      title={title ?? defaultTitle}
      allLink="/tours"
      additionalFilters="tourLocations"
      defaultFilter={Places.Anywhere.id}
      tileStyle="card-default"
      tileSize="medium"
      excludedIds={excludedIds}
      minimumOffersCount={minimumOffersCount}
      data-testid="tours-carousel"
    >
      <OfferCarouselLookingForSomethingElse to={to} />
    </OfferCardCarouselSection>
  )
}

export default TourOfferCarousel
